import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trans } from '../../../localization/language';
import { CUSTOM_SERVICE_URL } from '../../../constants';

class ContactCustomerService extends React.Component {
	render() {
		var csLink = CUSTOM_SERVICE_URL[this.props.userInfo.acc_country] || CUSTOM_SERVICE_URL['INTL'];
		return (
			<div className="content">
				<div className="content-item content-item--ipage">
					<div className="content-item__title">
						{(this.props.userInfo.email === '') ? trans('add_email_title') : trans('change_email_title')}
					</div>
					<div className="content-item__main">
						<div className="content-item--ipage__main">
							<div className="content__result">
								<div className="content__result-icon"></div>
								<div className="content__result-txt">
									{trans('please_contact')+' '}
									<a href={`${csLink}`} className="customer-service-link">{trans('customer_service')}</a>
									{' ' + trans('for email address change')}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
	}
}

export default connect(mapStateToProps, null)(ContactCustomerService);



// WEBPACK FOOTER //
// ./app/components/security/email/ContactCustomerService.js